import { render, staticRenderFns } from "./SideNavigation.vue?vue&type=template&id=311ecd7e&scoped=true&"
import script from "@/components/SideNavigation/SideNavigation.ts?vue&type=script&lang=ts&"
export * from "@/components/SideNavigation/SideNavigation.ts?vue&type=script&lang=ts&"
import style0 from "@/components/SideNavigation/SideNavigation.scss?vue&type=style&index=0&id=311ecd7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311ecd7e",
  null
  
)

export default component.exports